import { PF_PORTALS } from "../../services/payrollFinanceCalculator";

export const money = (value) => `PKR ${Number(value || 0).toLocaleString("en-PK", { minimumFractionDigits: 0, maximumFractionDigits: 1 })}`;

export const dateLabel = (date, time) => {
  if (!date) return "—";
  const label = new Date(`${date}T00:00:00Z`).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric", timeZone: "UTC" });
  return time ? `${label} ${time}` : label;
};

export const todayIso = () => new Date().toISOString().slice(0, 10);

export function PortalSelect({ value, onChange, allowAll = false, allowNone = false, label = "Portal" }) {
  return (
    <div className="field"><label>{label}</label>
      <select className="input" value={value} onChange={(e) => onChange(e.target.value)}>
        {allowAll && <option value="ALL">All portals</option>}
        {allowNone && <option value="">Not specific</option>}
        {PF_PORTALS.map((portal) => <option key={portal.code} value={portal.code}>{portal.label}</option>)}
      </select>
    </div>
  );
}

export const RECON_TONE = { COMPLETE: "success", NOT_RETURNED: "warning", PARTIAL: "warning", OVER: "danger" };

export function accountSuggestions(data) {
  const names = new Set();
  data.movements.forEach((m) => m.companyAccount && names.add(m.companyAccount));
  data.uses.forEach((u) => u.companyAccount && names.add(u.companyAccount));
  return [...names].sort();
}
